import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1)
const _hoisted_3 = {
  key: 0,
  id: "calendar-question-desc",
  class: "tw-question__description"
}
const _hoisted_4 = { class: "tw-form-control tw-form-control__with-icon--right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "tw-form-control__icon--right",
  alt: "",
  width: "39",
  height: "40",
  viewBox: "0 0 39 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.9824 5.7037H27.5806C32.9804 5.7037 37.3985 10.2894 37.3985 15.8808V19.7002",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.0625 5.7037H21.833",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M37.41 19.7122V28.2729C37.41 33.8763 32.9919 38.45 27.5921 38.45H10.8179C5.41805 38.45 1 33.8643 1 28.2729V15.8928C1 10.2894 5.41805 5.7037 10.8179 5.7037",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.92188 16.1202H31.6509",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.9434 23.4837H15.8705",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.7969 23.4837H27.724",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.9434 31.6972H15.8705",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.7969 31.6972H27.724",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.7188 1.99207V9.75059",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.8594 1.99207V9.75059",
    stroke: "#315E3D",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "checkbox__group" }
const _hoisted_8 = { class: "checkbox__item" }
const _hoisted_9 = ["id", "name"]
const _hoisted_10 = ["for"]
const _hoisted_11 = ["disabled", "placeholder", "aria-label", "aria-describedby", "aria-required", "aria-invalid"]
const _hoisted_12 = ["id"]

import FlatButton from '@/components/Shared/FlatButton.vue';
import { InterviewQuestionResponseModel } from '@/models/QuestionModels';
import { useInterviewStore } from '@/stores/interviewStore';
import Datepicker from '@vuepic/vue-datepicker';

import '@vuepic/vue-datepicker/dist/main.css'
import { ref, computed, watch, onMounted } from 'vue';
import { scrollToElementBottom } from '../scrollToElementBottom';

enum AnswerMode {
    dialog = 'dialog',
    freeText = 'freeText',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarQuestion',
  props: {
    question: null
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel };

const answerMode = ref<AnswerMode>(AnswerMode.dialog)

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => scrollToElementBottom(root!.value as HTMLElement));

const answer = ref<string | null>(null)
const freeTextAnswer = ref<string>('')

const isSubmited = ref<boolean>(false)


const touched = ref(false);

const interviewStore = useInterviewStore()
const calendarInputPlaceholder = interviewStore.getLocalization('InterviewQuestionary.Calendar.Placeholder')
const rawInputCheckboxText = interviewStore.getLocalization('InterviewQuestionary.Calendar.RawInputCheckbox')
const inputPlaceholder = interviewStore.getLocalization('InterviewQuestionary.Calendar.InputPlaceholder')

const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const errorMessage = computed(() => interviewStore.questionsAnswerError[props.question.Id])
const isSubmitable = computed(() => {
    validateField()
    return (answerMode.value === AnswerMode.dialog && !!answer.value) || (answerMode.value === AnswerMode.freeText && !!freeTextAnswer.value)
})

function toggleAnswerMode(): void {
    answerMode.value = answerMode.value === AnswerMode.freeText ? AnswerMode.dialog : AnswerMode.freeText

    onAnswerChoose()
}

function onAnswerChoose() {
    let result: string
    if (answerMode.value === AnswerMode.dialog) {
        result = answer?.value ?? ''
        //interviewStore.changeAutomaticTag(props.question.Id, true)
    } else {
        result = freeTextAnswer.value
        //interviewStore.changeAutomaticTag(props.question.Id, false)
    }

    interviewStore.changeAnswer(props.question.Id, result)
    emits('handleAnswerChoose', result)
}

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return
    }

    onAnswerChoose()
    interviewStore.nextQuestion()
    isSubmited.value = true
}

function validateField() {
    if((!(answerMode.value === AnswerMode.dialog && !!answer.value) && !(answerMode.value === AnswerMode.freeText && !!freeTextAnswer.value)) && touched.value)
    {
        interviewStore.questionsAnswerError[props.question.Id] = answerMode.value === AnswerMode.dialog ?
            interviewStore.getLocalization('Accessability.InterviewQuestionary.CalendarField.EmptyPicker') :
            interviewStore.getLocalization('Accessability.InterviewQuestionary.CalendarField.EmptyFreeText')
    }
    else
    {
        interviewStore.questionsAnswerError[props.question.Id] = null
    }
}

const ariaLabels = computed(() => {return {input: (errorMessage.value && answerMode.value === AnswerMode.dialog) ? errorMessage.value ?? "" : calendarInputPlaceholder ?? ""}})

watch(answer, (newValue) => {
    emits('handleAnswerChoose', newValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(__props.question.Description), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Datepicker), {
        dir: "rtl",
        placeholder: _unref(calendarInputPlaceholder),
        "aria-label": _unref(calendarInputPlaceholder),
        "aria-labels": _unref(ariaLabels),
        "aria-describedby": (_unref(errorMessage) && answerMode.value === AnswerMode.dialog) ? 'calendar-question-error-' + __props.question.Id : 'calendar-question-desc',
        modelValue: answer.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answer).value = $event)),
        modelModifiers: { lazy: true },
        "max-date": new Date(),
        "enable-time-picker": false,
        class: _normalizeClass(["tw-form-control__calendar", {
                            'pointer-none tw-form-control--disabled': answerMode.value === AnswerMode.freeText
                        }]),
        "input-class-name": answerMode.value === AnswerMode.dialog && !_unref(isSubmitable) && touched.value ? 'tw-form-control__field-error--highlight' : '',
        disabled: answerMode.value === AnswerMode.freeText,
        "auto-apply": "",
        "hide-input-icon": true,
        clearable: false,
        required: answerMode.value === AnswerMode.dialog,
        "aria-required": answerMode.value === AnswerMode.dialog,
        "aria-invalid": answerMode.value === AnswerMode.dialog && !_unref(isSubmitable)
      }, null, 8, ["placeholder", "aria-label", "aria-labels", "aria-describedby", "modelValue", "max-date", "input-class-name", "class", "disabled", "required", "aria-required", "aria-invalid"]),
      _hoisted_5
    ]),
    (_unref(errorMessage) && answerMode.value === AnswerMode.dialog)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "tw-question__error tw-question__error-calendar",
          id: 'calendar-question-error-' + __props.question.Id,
          role: "alert",
          "aria-live": "polite"
        }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("input", {
          class: "checkbox__input",
          type: "checkbox",
          id: 'ch' + __props.question.Id,
          name: 'ch' + __props.question.Id,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (toggleAnswerMode()))
        }, null, 40, _hoisted_9),
        _createElementVNode("label", {
          for: 'ch' + __props.question.Id,
          class: "checkbox__label"
        }, _toDisplayString(_unref(rawInputCheckboxText)), 9, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-form-control", { 'tw-form-control--disabled': answerMode.value === AnswerMode.dialog }])
    }, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((freeTextAnswer).value = $event)),
        inputmode: "numeric",
        disabled: answerMode.value === AnswerMode.dialog,
        placeholder: __props.question.Label ?? _unref(inputPlaceholder),
        "aria-label": __props.question.Label ?? _unref(inputPlaceholder),
        "aria-describedby": (_unref(errorMessage) && answerMode.value !== AnswerMode.dialog) ? 'calendar-free-question-error-' + __props.question.Id : 'calendar-question-desc',
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (touched.value = true)),
        rows: 1,
        "aria-required": answerMode.value === AnswerMode.freeText,
        "aria-invalid": answerMode.value === AnswerMode.freeText && touched.value && !_unref(isSubmitable),
        class: _normalizeClass(["tw-form-control__textarea", {
                    'tw-form-control__field-error--highlight': answerMode.value === AnswerMode.freeText && touched.value && !_unref(isSubmitable),
                    'tw-form-control__textarea--error': answerMode.value === AnswerMode.freeText && touched.value && !_unref(isSubmitable),
                    'tw-form-control__textarea--no-resize': true
                }])
      }, null, 42, _hoisted_11), [
        [_vModelText, freeTextAnswer.value]
      ])
    ], 2),
    (_unref(errorMessage) && answerMode.value !== AnswerMode.dialog)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          id: 'calendar-free-question-error-' + __props.question.Id,
          role: "alert",
          "aria-live": "polite",
          style: {"color":"red","text-align":"center"}
        }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_12))
      : _createCommentVNode("", true),
    (_unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 3,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})